<template>
  <auth-layout>
    <main class="forgot">
      <div class="forgot_header-gap"></div>
      <section class="forgot_cards">
        <forgot-password-form
          v-if="currentStep === 0"
          :error-message="errorMessage"
          :loading="loading"
          @submit="handleSubmitForgotPassoword"
        />
        <forgot-new-password-form
          v-if="currentStep === 1"
          :error-message="errorMessage"
          :loading="loading"
          @submit="handleSubmitForgotNewPassoword"
        />
        <forgot-final-form v-if="currentStep === 2" />
      </section>
    </main>
  </auth-layout>
</template>

<script>
import AuthLayout from '@/layouts/AuthLayout.vue';
import ForgotPasswordForm from './ForgotPasswordForm.vue';
import { authService } from '@/services/auth.service';
import { dialogService } from '@/services/dialog.service';
import ForgotNewPasswordForm from './ForgotNewPasswordForm.vue';
import ForgotFinalForm from './ForgotFinalForm.vue';

export default {
  name: 'Forgot',
  components: {
    AuthLayout,
    ForgotPasswordForm,
    ForgotNewPasswordForm,
    ForgotFinalForm,
  },
  data() {
    return {
      currentStep: 0,
      loading: false,
      errorMessage: null,
      email: null,
    };
  },
  watch: {
    currentStep() {
      this.errorMessage = null;
    },
  },
  mounted() {
    this.errorMessage = null;
  },
  methods: {
    async handleSubmitForgotPassoword({ email }) {
      try {
        this.errorMessage = null;
        this.loading = true;
        this.email = email;
        await authService.forgotPassword(email);
        dialogService.showConfirmDialog(
          {
            title: '認証コードを送信しました。',
            content: `認証コードをメールアドレスへ送信しました。
認証コードを入力して新しいパスワードを登録してください。`,
            cancel: false,
          },
          {
            classes: ['forgot_dialog'],
            width: 575,
            height: 238,
            adaptive: true,
          },
          () => {
            this.currentStep = 1;
          }
        );
      } catch (error) {
        this.errorMessage = error.message;
      } finally {
        this.loading = false;
      }
    },
    async handleSubmitForgotNewPassoword({ password, code }) {
      try {
        this.errorMessage = null;
        this.loading = true;
        await authService.submitForgotPassword(this.email, code, password);
        this.currentStep = 2;
      } catch (error) {
        this.errorMessage =
          '無効なコードが提供されました。もう一度コードをリクエストしてください。';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.forgot {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%;
  &_dialog {
    &.vm--modal {
      border-radius: 6px !important;
      box-shadow: none;
      padding: 0px 15px;
      background: transparent;
    }
    .confirmedDialog {
      &_actions {
        &.v-card__actions {
          margin-bottom: 0;
        }
      }
      .dialog_closeIcon.v-btn.v-btn--icon.v-size--default {
        right: 0;
        top: 0;
      }
      position: relative;
      &_actions {
        .confirmedDialog_btn-ok {
          &.v-btn:not(.v-btn--round).v-size--default {
            height: 30px;
          }
        }
      }
    }
  }

  &_cards {
    width: 100%;
  }
  &_logo {
    display: block;
    height: 24px;
    width: 165.4px;
    margin-bottom: 30px;
    margin-top: 40px;
  }
  @media (max-width: 576px) {
    &_dialog {
      .confirmedDialog_card {
        &.v-sheet {
          padding: 15px;
        }
      }
    }
    .v-sheet.v-card:not(.v-sheet--outlined) {
      width: 100%;
      padding: 20px;
    }
    &_cards {
      padding: 20px;
    }
    &_header-gap {
      display: none;
    }
    &_logo {
      margin-bottom: 0px;
      margin-top: 21px;
    }
  }
  &_header-gap {
    height: 100px;
  }

  &_footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 40px;

    &-title {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #333;
    }
    &-caption {
      margin: 10px 0;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #989898;
    }
  }
}
</style>
